export type PropertiesKey = string;

type Properties = Record<PropertiesKey, unknown>;

export type FieldProperties = Properties;

export type IssueTypeProperties = Properties;

/**
 * @deprecated instead use `src/packages/project-settings/issue-type-page-product-features-jsm-tmp/src/common/constants.tsx`
 */
export const JSD_ISSUE_TYPE_HELPTEXT: PropertiesKey = 'jsd.simplified.issue.type.helpText';

/**
 * @deprecated instead use `src/packages/project-settings/issue-type-page-product-features-jsm-tmp/src/common/constants.tsx`
 */
export const JSD_IS_EMAIL_REQUEST_TYPE: PropertiesKey = 'jsd.simplified.issue.type.isEmail';

/**
 * @deprecated instead use `src/packages/project-settings/issue-type-page-product-features-jsm-tmp/src/common/constants.tsx`
 */
export const JSD_FIELD_ALIAS: PropertiesKey = 'jsd.field.displayName';

/**
 * @deprecated instead use `src/packages/project-settings/issue-type-page-product-features-jsm-tmp/src/common/constants.tsx`
 */
export const JSD_FIELD_HELPTEXT: PropertiesKey = 'jsd.field.helpText';
export const JSD_FIELD_APPROVAL_CONFIG: PropertiesKey = 'jsd.field.approval.config';
export const JSD_FIELD_APPROVAL_ALL_CONFIGS: PropertiesKey = 'jsd.field.approval.all.configs';
